<template>
  <div ref="view" class="goods-page">
    <!-- 菜单栏（内嵌App时隐藏） -->
    <app-header :title="title" back-type="back-app" />
    <!-- 通用商品内容 -->
    <goods-content :content="goodsInfo.htmlContent" class="content" />
    <!-- 协议 -->
    <div class="warning" @click="checkProtocol" v-cloak>
      <img v-if="!canClick" src="../../../images/trainCamp/no.png" alt="" />
      <img v-else src="../../../images/trainCamp/yes.png" alt="" />
      我已阅读并知晓{{ campCourseType == 3 || campCourseType == 4 ? '训练营' : '' }}报名规则。
    </div>
    <!-- 购买btn -->
    <div class="foot">
      <div class="footer">
        <div class="btn" :class="{ none_box: !canCallUp }" v-if="canCallUp" @click="onClickPayBefore">
          立即报名，加入学习群
        </div>
        <div
          class="btn none_box"
          v-if="(joinStatus === -4 || callUpStatus === 3) && joinStatus !== 0"
          @click="onClickPayBefore"
        >
          已爆满
        </div>
        <div v-if="joinStatus === -2" class="btn none_box" @click="onClickPayBefore">未开始</div>
        <div class="btn none_box" v-if="joinStatus === 0" @click="onClickPayBefore">已报名</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Body from '@/mixins/body'
import { appUser, throttle } from '@/utils'
import { toLoginView } from '@/utils/init/env-init'
import GoodsComponents from '../../goods/components/goods'
import { Toast } from 'vant'
// import { sub } from '@/utils/compute-util'
// import { saTrack } from '@/utils/common/shence'

// 操作名称
const action = 'buyGoods'

export default {
  name: 'goods',
  components: {
    ...GoodsComponents
  },
  data() {
    return {
      title: '友邻少年',
      goodsList: [],
      goodsIndex: 0, // 选择购买商品的索引
      isShow: false,
      name: '',
      price: '',
      canClick: false,
      JoinTimes: 0, // 加入次数
      joinStatus: 0, // 营期状态
      callUpStatus: 0, // 是否已加入
      campCourseType: 0 // 营期类型  3畅听 4无限
    }
  },
  mixins: [Body],
  computed: {
    ...mapGetters('goods/vip', ['goodsDetail']),
    canCallUp() {
      return (
        (this.joinStatus === 1 ||
          this.joinStatus === -1 ||
          this.joinStatus === -3 ||
          this.joinStatus === -5 ||
          this.joinStatus === -6) &&
        this.callUpStatus !== 3
      )
    },
    goodsInfo() {
      const good = this.goodsDetail[this.goodsIndex] || {}
      good.htmlContent = good.guideContent || good.goodsContent
      if (!good.htmlContent) good.htmlContent = '<p><img class="wscnph" src="" /></p>'
      console.log('good.htmlContent------', good.htmlContent)
      return good
    }
  },
  activated() {
    const { goodsId, JoinTimes, joinStatus, callUpStatus, campCourseType } = this.$route.query
    this.JoinTimes = (JoinTimes || 0) * 1
    this.joinStatus = (joinStatus || 0) * 1
    this.callUpStatus = (callUpStatus || 0) * 1
    this.campCourseType = (campCourseType || 0) * 1
    this.goodsIdArr = [goodsId * 1]
    console.log('激活时---', goodsId, this.goodsIdArr, this.JoinTimes)
    this.getGoodsDetail()
  },
  mounted() {
    console.log('监听屏幕切换')
    window.addEventListener('onorientationchange' in window ? 'orientationchange' : 'resize', this.renderResize, false)
  },
  beforeDestroy() {
    window.removeEventListener(
      'onorientationchange' in window ? 'orientationchange' : 'resize',
      this.renderResize,
      false
    )
  },
  methods: {
    checkProtocol() {
      this.canClick = !this.canClick
    },
    renderResize() {
      console.log('屏幕切换啦')
      const { style, clientWidth, clientHeight } = document.documentElement
      if (window.orientation === 180 || window.orientation === 0) {
        // 竖屏
        style.fontSize = Math.min(clientWidth, clientHeight) / 7.5 + 'px'
      }
      if (window.orientation === 90 || window.orientation === -90) {
        // 横屏
        style.fontSize = Math.max(clientWidth, clientHeight) / 7.5 + 'px'
      }
      console.log('屏幕切换啦clientWidth:', clientWidth, clientHeight)
    },
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      const { goodsDetail: list } = this
      if (list.length === 1) {
        // USER-LOGIN-NEXT-ACTION: {"type":"button","action":"buyGoods"}
        this.enterAfterLogin(list)
      }
    },
    // 商品详情查询后，检查购买行为
    enterAfterLogin(res) {
      const { goodsInfoList: list } = res

      if (list && list.length) {
        console.log('enterAfterLogin init', list[0].goodsName, res)
        document.title = list[0].goodsName
      }
    },
    getGoodsDetail() {
      const data = {
        goodsIds: this.goodsIdArr || [],
        shareCode: this.shareCode || ''
      }
      this.$store
        .dispatch('goods/vip/getDetailByGoodsId', data)
        // 检查支付操作（登录成功之后）继续
        .then(this.enterAfterLogin)
    },
    // 设置分享数据
    setShareData() {
      const { shareMainTitle: title, shareSecondTitle: desc, shareImg: imgUrl } = this.goodsInfo
      if (title) {
        const link = location.href
        return { title, desc, link, imgUrl }
      }
    },
    // 检查用户
    hasUser() {
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    onClickPayBefore: throttle(
      function () {
        const { joinStatus, campCourseType, canClick, JoinTimes } = this
        switch (joinStatus) {
          case -1:
            Toast(
              `该服务为${
                campCourseType === 51
                  ? '畅听卡与无限卡会员'
                  : campCourseType === 3 || campCourseType === 31
                  ? '畅听卡'
                  : '无限卡'
              }会员专享`
            )
            return
          case -2:
            Toast('当前营期报名未开始')
            return
          case -3:
            Toast('当前营期报名已结束')
            return
          case -4:
            Toast('当前营期已报满')
            return
          case -5:
            Toast('本年度报名次数已用完，无法继续报名～')
            return
          case -6:
            Toast('学习时间冲突，您已报名其他营期')
            return
          case -7:
            joinMessage && Toast(joinMessage)
            return
        }
        if (!canClick) {
          return Toast('请先阅读并勾选报名规则')
        }
        if (JoinTimes === 0 && joinStatus !== 0) {
          return Toast('本年度报名次数已用完，无法继续报名～')
        }
        if (!this.hasUser()) return
        this.onClickPay()
      },
      3000,
      { leading: true }
    ),
    onClickPay() {
      const { goodsId } = this.goodsInfo
      this.$store
        .dispatch('trainCamp/index/trainJoin', {
          campPeriodId: goodsId
          // userId: appUser.userId
        })
        .then(res => {
          this.goNext(goodsId, res)
        })
        .catch(info => {
          // this.$router.push('/joinSuccess')
          console.log(info)
          // if (info.code === 50001) {  已报满
          //   this.goNext(goodsId, info.data)
          // }
        })
    },
    goNext(goodsId, res) {
      this.$store.commit('payment/order/setPayStatus', {
        goodsId,
        userId: appUser.userId,
        ...res
      })
      this.$router.replace({
        path: '/joinSuccess',
        query: {
          id: goodsId
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.goods-page {
  &::-webkit-scrollbar {
    display: none;
    background-color: transparent;
  }
  padding-bottom: 2rem;
  .content {
    img {
      width: 100%;
      height: auto;
    }
  }
  .foot {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    height: 1.3rem;
    align-items: center;
    display: flex;
    border-top: 1px solid #eeeeee;
    // iphoneX only
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    background-color: #fff;

    .footer {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0.18rem 0.47rem;
      border-top: none !important;
      background-color: #fff;
      .btn {
        width: 100%;
        padding: 0.24rem 0.4rem;
        background-color: #00b25a;
        border-radius: 0.12rem;
        font-size: 0.3rem;
        color: #fff;
        text-align: center;
      }
    }
    .none_box {
      opacity: 0.6;
    }
  }
  .warning {
    position: fixed;
    left: 0;
    bottom: 1.3rem;
    display: flex;
    width: 100%;
    align-items: center;
    background: #fff2cc;
    padding: 0.07rem 0.1rem 0.07rem 0.24rem;
    font-size: 0.24rem;
    height: 0.8rem;
    img {
      display: block;
      width: 0.32rem;
      height: 0.32rem;
      margin-right: 5px;
    }
  }
}
</style>
